<!--vip详情上部分老师信息 依赖vuex vip data-->
<template>
<div class="vip_teacher_info clearfix" v-if="data">
  <div class="img_wrap left">
    <img v-lazy="isSupportWebp(data.teacherAvatar)" :alt="data.teacherName" />
  </div>
  <div class="info_wrap left">
    <p class="title">
      <span v-if="data.id">{{ data.title }}</span>
      <span v-if="isG" class="cup" :class="{ g: isG }"></span>
      <span v-if="isA || isB || isC || isD" class="cup" :class="{ a: isA, b: isB, c: isC, d: isD }"></span>
      <span v-if="isE" class="cup" :class="{ e: isE }"></span>
      <img :src="require(`../../assets/vip_topinfo_${data.status ? 'open' : 'close'}.png`)" :alt="data.status ? '开启' : '关闭'" />
    </p>
    <p class="name_wrap">
      <span>主讲人：{{ data.teacherName }}</span>
      <span>创建时间：{{ data.createdAt.slice(0, 10) }}</span>
    </p>
    <p class="action_wrap yf-text_12">
      <span v-for="(w, index) in data.keywords" :key="index">{{ w }}</span>
    </p>
  </div>
</div>
</template>

<script>
import { Cup2018 } from '@/mixins/Cup-2018'
import Webp from '@/mixins/Webp'

export default {
  name : 'component-vip-header',
  mixins: [Cup2018, Webp],
  computed: {
    data () {
      return this.$store.state.vip.data
    }
  }
}
</script>

<style lang="less" scoped>
.vip_teacher_info {
  height: 175px; background: url(~assets/vip_detail_top.jpg) no-repeat;
  .img_wrap {
    width: 180px; padding: 30px 0 0 40px;
    img { width: 120px; height: 120px; border: 9px solid #7d6573; border-radius: 50%; display: block; }
  }
  .info_wrap {
    padding-top: 40px; color: #fff;
    .title {
      span { display: inline-block; font-size: 16px; vertical-align: middle; margin-right: 6px; }
      img { vertical-align: middle; margin-left: 6px;}
    }
    .name_wrap {
      padding-top: 14px;
      span { font-size: 14px; margin-right: 16px; }
    }
    .action_wrap {
      padding-top: 18px;
      span { border: 1px dashed #ffcc00; margin-right: 8px; padding: 8px 19px; color: #ffcc00; }
    }
  }
}
</style>
